import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import fr from "./locales/fr/translation.json";
import ro from "./locales/ro/translation.json";
import pl from "./locales/pl/translation.json";
import es from "./locales/es/translation.json";

/**
 * i18next configuration.
 *
 * - English is the default and the fallback language.
 * - The detector reads the user's choice from localStorage (key "language")
 *   first, then the browser language; the chosen value is cached back so it
 *   persists across sessions.
 * - Translations are bundled (no async backend) — small enough to ship in the
 *   main bundle. Add i18next-http-backend later if the catalog grows.
 */

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "ro", label: "Română" },
  { code: "pl", label: "Polski" },
  { code: "es", label: "Español" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      ro: { translation: ro },
      pl: { translation: pl },
      es: { translation: es },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    load: "languageOnly", // treat "en-US" as "en"
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "language",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
